module.exports = __webpack_public_path__ + "static/media/PM77.bd34cf9c.JPG";